import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthProvider';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './store';
import './i18n';
import { initElfLogging, ElfRouteLogger } from './service/logging';
const { BASENAME } = require('./helper/application-conf').default;

// Bootstrap ELF (Enterprise Logging Framework) client logging before render, so
// early errors and the initial navigation are captured.
initElfLogging();

const root = ReactDOM.createRoot(
  document.querySelector('#root') as HTMLElement
);
const SITE_NAME = window.location.pathname.split('/')[2];
const basename = `${BASENAME}/${SITE_NAME}`;

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <BrowserRouter basename={basename}>
          <ElfRouteLogger />
          <App />
        </BrowserRouter>
      </AuthProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
